import Vue from 'vue'
import Router from 'vue-router'
import { store } from './store/store'

import Teams from './components/Teams'
import Games from './components/Games'
import Questions from './components/Questions'
import QuestionForm from './components/QuestionForm'
import LoginForm from './components/LoginForm'
import QuestionSelector from './components/single/QuestionSelector'
import CreateTeam from './components/single/CreateTeam'
import ViewTeamProgress from './components/single/ViewTeamProgress'
import CreateGames from './components/CreateGames'
import GameCompletion from './components/GameCompletion'
import Leaderboard from './components/Leaderboard'
import GameSummary from './components/GameSummary'
import PreviewGame from './components/PreviewGame'

import EditGames from './components/EditGames'
import Help from './components/Help'
import Billing from './components/Billing'
import DuplicateGames from './components/DuplicateGames'
import MainScreen from './components/MainScreen'
import Maps from './components/Maps'
import MapImport from './components/MapImport'
import ExpertMode from './components/ExpertMode'
import Packs from './components/Packs'
import CreatePack from './components/single/CreatePack'
import ActivityPackAssociation from './components/single/ActivityPackAssociation'
import RawActivities from './components/RawActivities'
import CreateRawActivity from './components/single/CreateRawActivity'
import RawActivitiesImport from './components/RawActivitiesImport'
import Admin from './components/Admin'
import SpecialFeatures from './components/SpecialFeatures'
import AdminUserForm from './components/AdminUserForm'
import AdminUsers from './components/AdminUsers'
import TenantForm from './components/TenantForm'
import Tenants from './components/Tenants'
import AuthTokenForm from './components/AuthTokenForm'
import GenerateChallenges from './components/GenerateChallenges'
import PreviewMap from './components/PreviewMap'
import Calendar from './components/Calendar'
import IntroTexts from './components/IntroTexts'
import CreateIntroText from './components/single/CreateIntroText'
import CreateGameInSteps from './components/games/CreateGameInSteps'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/questions',
      name: 'Questions',
      component: Questions,
      beforeEnter: requireAuth
    },
    {
      path: '/gamesummary/:id/:name',
      name: 'GameSummary',
      component: GameSummary,
      beforeEnter: requireAuth
    },
    {
      path: '/questions/add',
      name: 'QuestionForm',
      component: QuestionForm,
      beforeEnter: requireAuth
    },
    {
      path: '/questions/:id/edit',
      name: 'EditQuestionForm',
      component: QuestionForm,
      beforeEnter: requireAuth
    },
    {
      path: '/games/:id/questions?gameName=:name',
      name: 'QuestionSelector',
      component: QuestionSelector,
      beforeEnter: requireAuth
    },
    {
      path: '/',
      name: 'LoginForm',
      component: LoginForm,
    },
    {
      path: '/games/:id/teams',
      name: 'Teams',
      component: Teams,
      beforeEnter: requireAuth
    },
    {
      path: '/games/:id/previewgame',
      name: 'PreviewGame',
      component: PreviewGame,
      beforeEnter: requireAuth
    },
    {
      path: '/games/:id/teams/create',
      name: 'CreateTeam',
      component: CreateTeam,
      beforeEnter: requireAuth
    },
    {
      path: '/games/:id/teams/:idTeam/edit',
      name: 'EditTeam',
      component: CreateTeam,
      beforeEnter: requireAuth
    },
    {
      path: '/games/:id/teams/:idTeam/progress',
      name: 'ViewTeamProgress',
      component: ViewTeamProgress,
      beforeEnter: requireAuth
    },
    {
      path: '/games',
      name: 'Games',
      component: Games,
      beforeEnter: requireAuth
    },
    {
      path: '/games/create',
      name: 'CreateGames',
      component: CreateGames,
      beforeEnter: requireAuth
    },
    {
      path: '/games/:id/duplicate?gameName=:name',
      name: 'DuplicateGames',
      component: DuplicateGames,
      beforeEnter: requireAuth
    },
    {
      path: '/games/:id/edit',
      name: 'EditGames',
      component: EditGames,
      beforeEnter: requireAuth
    },
    {
      path: '/games/:id/GameCompletion?gameName=:name',
      name: 'GameCompletion',
      component: GameCompletion,
      beforeEnter: requireAuth
    },
    {
      path: '/games/:id/leaderboard?gameName=:name',
      name: 'Leaderboard',
      component: Leaderboard,
      beforeEnter: requireAuth
    },
    {
      path: '/maps',
      name: 'Maps',
      component: Maps,
      beforeEnter: requireAuth
    },
    {
      path: '/maps/import',
      name: 'MapImport',
      component: MapImport,
      beforeEnter: requireAuth
    },
    {
      path: '/help',
      name: 'Help',
      component: Help
    },
    {
      path: '/billing',
      name: 'Billing',
      component: Billing,
      beforeEnter: requireAuth
    },
    {
      path: '/mainscreen',
      name: 'MainScreen',
      component: MainScreen,
      beforeEnter: requireAuth
    },
    {
      path: '/expertmode',
      name: 'ExpertMode',
      component: ExpertMode,
      beforeEnter: requireAuth
    },
    {
      path: '/packs',
      name: 'Packs',
      component: Packs,
      beforeEnter: requireAuth
    },
    {
      path: '/packs/create',
      name: 'CreatePack',
      component: CreatePack,
      beforeEnter: requireAuth
    },
    {
      path: '/packs/:id/edit',
      name: 'EditPack',
      component: CreatePack,
      beforeEnter: requireAuth
    },
    {
      path: '/packs/:id/rawActivities?packName=:name',
      name: 'ActivityPackAssociation',
      component: ActivityPackAssociation,
      beforeEnter: requireAuth
    },
    {
      path: '/rawActivities',
      name: 'RawActivities',
      component: RawActivities,
      beforeEnter: requireAuth
    },
    {
      path: '/rawActivities/create',
      name: 'CreateRawActivity',
      component: CreateRawActivity,
      beforeEnter: requireAuth
    },
    {
      path: '/rawActivities/:id/edit',
      name: 'EditRawActivity',
      component: CreateRawActivity,
      beforeEnter: requireAuth
    },
    {
      path: '/games/rawActivities/import',
      name: 'RawActivitiesImport',
      component: RawActivitiesImport,
      beforeEnter: requireAuth
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Admin,
      beforeEnter: requireAuth
    },
    {
      path: '/specialfeatures',
      name: 'SpecialFeatures',
      component: SpecialFeatures,
      beforeEnter: requireAuth
    },
    {
      path: '/adminUsers',
      name: 'AdminUsers',
      component: AdminUsers,
      beforeEnter: requireAuth
    },
    {
      path: '/adminUsers/add',
      name: 'AdminUserForm',
      component: AdminUserForm,
      beforeEnter: requireAuth
    },
    {
      path: '/adminUsers/:id/edit',
      name: 'EditAdminUserForm',
      component: AdminUserForm,
      beforeEnter: requireAuth
    },
    {
      path: '/tenants',
      name: 'Tenants',
      component: Tenants,
      beforeEnter: requireAuth
    },
    {
      path: '/changeTenant',
      name: 'ChangeTenant',
      component: AuthTokenForm,
      beforeEnter: requireAuth
    },
    {
      path: '/tenants/add',
      name: 'TenantForm',
      component: TenantForm,
      beforeEnter: requireAuth
    },
    {
      path: '/tenants/:id/edit',
      name: 'EditTenantForm',
      component: TenantForm,
      beforeEnter: requireAuth
    },
    {
      path: '/maps/:mapId/generatechallenges',
      name: 'GenerateChallenges',
      component: GenerateChallenges,
      beforeEnter: requireAuth
    },
    {
      path: '/maps/:mapId/previewmap',
      name: 'PreviewMap',
      component: PreviewMap,
      beforeEnter: requireAuth
    },
    {
      path: '/games/createGameInSteps',
      name: 'CreateGameInSteps',
      component: CreateGameInSteps,
      beforeEnter: requireAuth
    },
    {
      path: '/games/createGameInSteps/:id/edit',
      name: 'EditGameInSteps',
      component: CreateGameInSteps,
      beforeEnter: requireAuth
    },
    {
      path: '/calendar',
      name: 'Calendar',
      component: Calendar,
      beforeEnter: requireAuth
    },
    {
      path: '/introTexts',
      name: 'IntroTexts',
      component: IntroTexts,
      beforeEnter: requireAuth
    },
    {
      path: '/introTexts/create',
      name: 'CreateIntroText',
      component: CreateIntroText,
      beforeEnter: requireAuth
    },
    {
      path: '/introTexts/:id/edit',
      name: 'EditIntroText',
      component: CreateIntroText,
      beforeEnter: requireAuth
    }
  ],
})

function requireAuth (to, from, next) {
  if (!store.getters.isLoggedIn) {
    console.log('Not authorised.. routing to login')
    next({
      path: '/',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
}

export default router
